import React, { useEffect, useState, useRef } from 'react'

function AppIcon({ iconName, customClass, isDynamic }) {
  const [loading, setLoading] = useState(isDynamic)
  const [iconCode, setIconCode] = useState('false')

  useEffect(() => {
    if (isDynamic) {
      fetch(`http://localhost:8000/${iconName}`)
        .then((r) => r.text())
        .then((text) => {
          setIconCode(text)

        })
        .catch(console.error.bind(console))
        .finally(setLoading(false))
    } else {
      setLoading(false)
    }
  }, [])

  return (
    <>
      {loading ? (
        <div></div>
      ) : (
        <>
          {isDynamic && !loading ? (
            <></>
          ) : (
            <div>
              <img
                src={`/images/appIcons/${iconName ?? 'mail'}.svg`}
                alt={`Icon--${iconName}`}
              />
            </div>
          )}
        </>
      )}
    </>
  )
}

export default AppIcon
